import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/chat/chat.component').then((m) => m.ChatComponent),
    pathMatch: 'full',
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./pages/chat/chat.component').then((m) => m.ChatComponent),
  },
  {
    path: 'results',
    loadComponent: () =>
      import('./pages/results/results.component').then(
        (m) => m.ResultsComponent,
      ),
  },
  {
    path: 'invite',
    loadComponent: () =>
      import('./pages/invite/invite.component').then((m) => m.InviteComponent),
  },
  {
    path: 'debug',
    loadComponent: () =>
      import('./pages/debug/debug.component').then((m) => m.DebugComponent),
  },
];
